import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { OwnershipGroupsDropdown } from './OwnershipGroupsDropdown';

export const OwnershipGroupsDropdownFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'OwnershipGroupsDropdown',
    component: OwnershipGroupsDropdown,
  }),
);
